<template>
  <div>
    <p v-html="data.intro"></p>
    <div class="yt-container">
        <iframe :src="'https://www.youtube.com/embed/'+data.video_code+'?enablejsapi=1'" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</template>
<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'YouTube',
  props: ['id', 'type', 'data', 'standard', 'title'],
  methods: {
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: 'n/a',
        answer: 'n/a',
        description: this.title,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
  },
  mounted() {
    if (this.standard === 'SCORM_2004') {
      this.saveSCORMInteraction();
    }
  },
};
</script>
<style scoped>
.yt-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    max-width: 100%;
}

.yt-container iframe,
.yt-container object,
.yt-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100%;
}
</style>
